import { create } from 'zustand';
import { ClubLinkBranchInfoType } from '../../Types/landing.type';
import { getContactUsDataAction } from './actions';

type ContactUsType = {
  contactUsData: ClubLinkBranchInfoType[];
  contactUsLoading: boolean;
  contactUsError: boolean;
  getContactUsDataAction: (uniqueId: number) => void;
};

const useContactUsStore = create<ContactUsType>((set) => ({
  contactUsData: null,
  contactUsLoading: false,
  contactUsError: false,
  getContactUsDataAction: (uniqueId) => getContactUsDataAction(set, uniqueId)
}));

export default useContactUsStore;
